import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css'
import logo from './images/logo.png'
// import  bannerbg from './images/banner-bg.png';
const Navbar = () => {
  return (
    <nav className="container">
    <div className="navbar bg-color" style={{padding:"0"}}>
        <a className="navbar-brand" href="/">
            <img src={logo} alt="logo"/>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNavDropdown">
      <ul className="navbar-nav">
            <li className="nav-item">
                <Link to='/' className="nav-link active" aria-current="page" href="/">Home</Link>
            </li>
            <li className="nav-item">
                <Link to='/products' className="nav-link" href="/">Products</Link>
            </li>
            <li className="nav-item">
                <Link to='/contact' className="nav-link" href='/'>Contact Us</Link>
            </li>
        </ul>
    </div>
        </div>
</nav>

  )
}

export default Navbar